import { LANGUAGE_DICTIONARY } from "./Languages";
import { userSettings } from "../globals/userSettings";
import { pluginConfig } from "@/globals/pluginConfig";

export function t(label: string): string {
    const dictionary = LANGUAGE_DICTIONARY[userSettings.lang] ?? LANGUAGE_DICTIONARY[pluginConfig.language.default];
    return dictionary[label] ?? label;
}